import { render, staticRenderFns } from "./editGoodsCard.vue?vue&type=template&id=387017fc&scoped=true"
import script from "./editGoodsCard.vue?vue&type=script&lang=ts"
export * from "./editGoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./editGoodsCard.vue?vue&type=style&index=0&id=387017fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387017fc",
  null
  
)

export default component.exports